import { invalidateItemQueries } from '@/shared/api/invalidate-item-queries';
import { trpc } from '@/shared/api/trpc';

export const useUpdateItemParticipants = () => {
  const utils = trpc.useUtils();
  return trpc.operations.updateItemParticipants.useMutation({
    onSettled: () => {
      invalidateItemQueries(utils);
      utils.itineraryPricing.budget.invalidate();
    },
  });
};
